import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DashboardIcon from '@mui/icons-material/Dashboard';
import BarChartIcon from '@mui/icons-material/BarChart';
import { t } from "@lingui/core/macro";

export function mainListItems(navigate) {
    return (
        <React.Fragment>
            <ListItemButton
                key="Dashboard"
                aria-label="Dashboard"
                onClick={() => navigate('/dashboard')}
            >
                <ListItemIcon>
                    <DashboardIcon/>
                </ListItemIcon>
                <ListItemText primary={t`Dashboard`}/>
            </ListItemButton>
            <ListItemButton
                key="Reports"
                aria-label="Reports"
                onClick={() => navigate('/dashboard/reports')}
            >
                <ListItemIcon>
                    <BarChartIcon/>
                </ListItemIcon>
                <ListItemText primary={t`Reports`}/>
            </ListItemButton>
        </React.Fragment>
    );
}
